import React from 'react';

import { Checkbox, Input, Modal, Table } from 'antd';

type IOtherCommentProps = {
    isOpen: boolean;
    onClose: () => void;
    data: any;
    isLoading: boolean;
};

export const OtherCommentComponent = ({ isOpen, onClose, data, isLoading }: IOtherCommentProps) => {
    const columns = [
        {
            title: <span className='fw-bold'>Người ý kiến</span>,
            key: 'userName',
            width: 250,
            render: item => item?.evaluatePerformerName ? `${item?.evaluateLevelName} - ${item?.evaluatePerformerName}` : item?.versionName
        },
        {
            title: <span className='fw-bold'>Đồng ý</span>,
            key: 'isAgree',
            width: 120,
            dataIndex: 'isAgree',
            render: item => <Checkbox checked={item} disabled />,
        },
        {
            title: <span className='fw-bold'>Ý kiến</span>,
            key: 'feedbackContent',
            width: 250,
            dataIndex: 'feedbackContent',
        },
    ]
    return (
        <Modal open={isOpen} maskClosable={false} footer={null} onCancel={onClose} width={'50vw'} className='view'>
            <Table columns={columns} dataSource={
                data?.map(x => ({
                    key: x.versionName,
                    versionName: x.versionName,
                    children: x.approvalFeedbackItems?.map(item => ({
                        ...item,
                        key: `${item.evaluateLevelName}-${item.evaluatePerformerName}`
                    }))
                }))
            } loading={isLoading} pagination={false} />
        </Modal>
    );
};

export default OtherCommentComponent;
